import cloneDeep from 'lodash/cloneDeep';

import type { Page } from '../common';
import { initialPage } from '../common';

export const NEW_PAGE_NAME = 'Страница';

export interface PagesState {
    pages: Array<Page>;
    curPage: Page;
    activePageId: number;
    fetch: boolean;
}

export const initialState: Readonly<PagesState> = {
    pages: [],
    curPage: cloneDeep(initialPage),
    activePageId: null,
    fetch: true,
};
